/*
	***
		All values of the variables are based on Bootstrap Breakpoints
	***
	https://getbootstrap.com/docs/4.2/layout/overview/
*/

export const SCREEN_BREAKPOINT = {
	sm: 576,
	md: 768,
	lg: 992,
	xl: 1200,
	
	// Max variables
	smMax: 767.98,
	mdMax: 991.981,
	lgMax: 1199.98,
}